import PhraseParentheses from "./PhraseParentheses";

const TokenElement = ({ element, lineHeight, handleClickToken }) => {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
      }}
    >
      {element.phraseStart.map((phrase) => (
        <PhraseParentheses phrase={phrase} isStart={true} />
      ))}
      <div
        style={{
          marginTop: "20px",
          marginBottom: `calc(${lineHeight} - 20px)`,
        }}
        onClick={() => handleClickToken()}
      >
        {element.text}
      </div>
      {element.phraseEnd.map((phrase) => (
        <PhraseParentheses phrase={phrase} isStart={false} />
      ))}
      <div>{element.space_right > 0 && " "}</div>
    </div>
  );
};

export default TokenElement;
